import { defineMessages } from 'react-intl';

export default defineMessages({
  list: {
    id: 'tnc.list',
    defaultMessage: 'Terms & Condition List',
  },
  update: {
    id: 'tnc.update',
    defaultMessage: 'Update Terms & Condition',
  },
  form: {
    name: {
      id: 'tnc.form.name',
      defaultMessage: 'File Name',
    },
    nameExtra: {
      id: 'tnc.form.nameExtra',
      defaultMessage:
        'This field indicate the purpose of the terms and condition.',
    },
    version: {
      id: 'tnc.form.version',
      defaultMessage: 'File Version',
    },
    versionExtra: {
      id: 'tnc.form.versionExtra',
      defaultMessage: 'File version is generated automatically by system.',
    },
    prev: {
      id: 'tnc.form.prev',
      defaultMessage: 'Previous Version',
    },
    empty: {
      id: 'tnc.form.empty',
      defaultMessage: 'Terms & Condition content is empty',
    },
  },
});
